import type { ThemeDefinition } from "vuetify";

export const theme_light: ThemeDefinition = {
   dark: false,
   colors: {
      primary: '#00920f',
      primaryHover: '#00c320',
      secondary: '#5F5F5F',
      tertiary: '#16411a',
      accent: '#ffa928',
      info: '#20a2f0',
      success: '#0aa669',
      warning: '#ff9b00',
      surface: '#d9d9dd',
      surfaceLight: '#f4f4f4',
      surfaceDark: '#d0d0d2',
      surfaceEdgeTop: '#fdfdff',
      surfaceEdgeRight: '#c6c6c8',
      surfaceEdgeBottom: '#b4b4b6',
      surfaceEdgeLeft: '#e4e4e9'
   }
};

export const theme_dark: ThemeDefinition = {
   dark: true,
   colors: {
      primary: '#00c147',
      primaryHover: '#00f050',
      secondary: '#ababb0',
      tertiary: '#16411a',
      accent: '#ffa928',
      info: '#20a2f0',
      success: '#0aa669',
      warning: '#ff9b00',
      surface: '#202022',
      surfaceLight: '#2d2d30',
      surfaceDark: '#1c1c1d',
      surfaceEdgeTop: '#323235',
      surfaceEdgeRight: '#1a1a1b',
      surfaceEdgeBottom: '#0a0a10',
      surfaceEdgeLeft: '#29292a'
   }
};